import React, { useState, memo, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setWarning, selectCurrentWarning } from '~/store/app/warning';
import { useCheckMerchantList } from '~/requests/providerService/useRequestMerchants';
import { useLanguage, useNavigation, useProvider } from '~/Hooks';
import { useLocation } from 'react-router-dom';
import RectangularButton from '~/Components/RectangularButton/RectangularButton';
import { Alert } from '~/UIKit/Alert';
import { Route } from '~/Constants/Routes.constants';
import { CreateMerchant } from '~/ScreensOrganisation/OrganisationMerchant/CreateMerchant';

export const MerchantBanner = memo(
  () => {
    const { navigate } = useNavigation();
    const loc = useLocation();
    const { currentProvider } = useProvider();
    const hasGlobalWarning = useSelector(selectCurrentWarning);
    const { t } = useLanguage();
    const dispatch = useDispatch();
    const changeWarning = bindActionCreators(setWarning, dispatch);
    const [openCreateMerchant, setOpenCreateMerchant] = useState(false);
    const { isOrganisationView, isSuperAdmin, merchantList } = useCheckMerchantList({
      changeWarning,
    });

    const onAlertClick = useCallback(() => {
      const { pathname } = loc || { pathname: '' };
      if (pathname.includes(Route.ORGANISATION_ROOT)) {
        navigate(Route.ORGANISATION_MERCHANT, { domain: currentProvider?.domain || '' });
      } else if (pathname.includes(Route.PROVIDER_ROOT)) {
        setOpenCreateMerchant(true);
      }
    }, [hasGlobalWarning, loc]);

    useEffect(() => {
      if (hasGlobalWarning && !isOrganisationView && !isSuperAdmin) {
        onAlertClick();
      }
    }, [hasGlobalWarning, isOrganisationView, isSuperAdmin]);

    return (
      <>
        <CreateMerchant
          open={openCreateMerchant}
          setOpen={setOpenCreateMerchant}
          merchantList={merchantList}
        />
        {hasGlobalWarning && (
          <Alert
            message={t('merchant.alert')}
            id="global_alert"
            severity="error"
            customAction={
              <RectangularButton onClick={onAlertClick}>
                {t('merchant.alert.action')}
              </RectangularButton>
            }
            fullScreen
          />
        )}
      </>
    );
  },
  () => true,
);
